<template>
  <v-container id="productos_lote" tag="section">
    <base-v-component heading="Producto por lote a restaurantes" />
    <base-material-card
      color="indigo"
      icon="mdi-basket"
      inline
      class="px-5 py-3"
    >
      <v-card-text>
        <v-row>
          <v-col cols="12" md="6">
            <v-select
              label="Catálogo"
              v-model="catalogoViendo"
              :items="catalogosSelect"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4">
            <v-card-title class="justify-center">
              Desglose producto
            </v-card-title>
            <v-list>
              <v-list-item-group
                v-model="eleccionLote"
                color="primary"
                mandatory
              >
                <v-list-item value="producto">
                  <v-list-item-content>
                    <v-list-item-title
                      v-text="mostrarIdioma(producto.nombre)"
                    ></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>

                <template
                  v-for="(panel, i) in producto.opciones"
                  value="producto"
                >
                  <v-subheader inset :key="i">
                    Panel {{ mostrarIdioma(panel.panel) }}
                  </v-subheader>
                  <v-list-item
                    v-for="op in panel.opciones"
                    :key="op.id"
                    :value="`opcion_${op.id}`"
                  >
                    <v-list-item-content>
                      <v-list-item-title
                        v-text="mostrarIdioma(op.title)"
                      ></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-list-item-group>
            </v-list>
          </v-col>
          <v-col cols="12" md="8">
            <v-card-title class="justify-center"> Restaurantes </v-card-title>
            <v-data-table
              :items="restaurantesFiltrados"
              disable-pagination
              hide-default-footer
              :headers="headers"
              dense
            >
              <template v-slot:item="{ item }">
                <tr>
                  <td>{{ item.nombreMostrar }}</td>
                  <td>
                    <span v-if="item.asociado === '-'">{{
                      item.asociado
                    }}</span>
                    <v-checkbox
                      :loading="item.loading"
                      v-else
                      class="ma-0"
                      dense
                      v-model="item.asociado"
                      @change="cambiarAsociado(item)"
                      hide-details
                    />
                  </td>
                  <td>
                    <span v-if="item.precio === '-'"> - </span>
                    <v-text-field
                      v-else
                      type="number"
                      step="0.01"
                      @change="cambiarAsociado(item)"
                      dense
                      hide-details
                      :loading="item.loading"
                      v-model="item.precio"
                      label="precio"
                    />
                  </td>
                  <td>
                    <span v-if="!item.asociado || eleccionLote !== 'producto'">
                      -
                    </span>
                    <v-select
                      v-else
                      :label="item.impuesto"
                      v-model="item.impuesto"
                      :items="impuestos"
                      @change="cambiarAsociado(item)"
                      dense
                      hide-details
                    />
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </base-material-card>
  </v-container>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { mostrarIdioma } from "@/utils/utils.js";
import { idToTexto } from "@/utils/utils.js";

export default {
  data() {
    return {
      producto: null,
      eleccionLote: null,
      catalogoViendo: null,
      catalogosConsultados: [], //catálogos de todos los restaurantes, tras llamada a acción
      restaurantesFiltrados: [],
      headers: [
        {
          sortable: false,
          text: "Restaurante",
          value: "nombreMostrar",
        },
        {
          sortable: false,
          text: "Asociado",
          value: "asociado",
        },
        {
          sortable: false,
          text: "Precio",
          value: "precio",
        },
        {
          sortable: false,
          text: "Impuesto",
          value: "impuesto",
        },
      ],
      timeout: null,
    };
  },
  watch: {
    eleccionLote(v) {
      this.calcularRestaurantesFiltrados();
    },
    catalogoViendo(v) {
      const _vm = this;
      this.$store
        .dispatch("catalogos/getCatalogoArrayRest", {
          arrayRest: this.restaurantes,
          catalogo: this.catalogoViendo,
        })
        .then((r) => {
          _vm.catalogosConsultados = r;
          _vm.calcularRestaurantesFiltrados();
        });
    },
  },
  computed: {
    ...mapState({
      restaurantes: (state) => state.restaurantes.restaurantesArray,
    }),
    catalogosSelect() {
      return this.$store.state.catalogos.catalogos;
    },
    ...mapGetters({
      negocio: "app/negocioGestObj",
      impuestos: "impuestos/getImpuestosSelect",
    }),
  },
  methods: {
    calcularRestaurantesFiltrados() {
      if (!this.catalogoViendo || !this.catalogosConsultados)
        this.restaurantesFiltrados = [];
      this.restaurantesFiltrados = this.restaurantes.map((r) => {
        let activo = false;
        let precio = 0;
        let impuesto;
        var catalogoFound = this.catalogosConsultados.find(
          (c) => c.rest == r.id
        );
        var foundProductoRest = null;
        if (catalogoFound) {
          foundProductoRest = catalogoFound.productos.find(
            (p) => p.id == this.producto.id
          );
        }
        if (foundProductoRest) {
          if (this.eleccionLote == "producto") {
            precio = foundProductoRest.precio
              ? foundProductoRest.precio
              : this.producto.precioGlobal;
            activo = foundProductoRest.activo;
            impuesto = foundProductoRest.impuesto
              ? foundProductoRest.impuesto
              : r.impuesto;
          } else {
            console.log(foundProductoRest);
            impuesto = "-";
            let idBuscar = this.eleccionLote
              ? this.eleccionLote.replace("opcion_", "")
              : null;
            console.log(foundProductoRest);
            var foundOpciones = Array.isArray(foundProductoRest.opciones)
              ? foundProductoRest.opciones.find((op) => op.id == idBuscar)
              : false;
            if (foundOpciones) {
              activo = foundOpciones.activo;
              precio = foundOpciones.activo
                ? parseFloat(foundOpciones.precio)
                : "-";
            } else {
              activo = false;
              precio = "-";
            }
          }
        } else {
          if (this.eleccionLote == "producto") {
            precio = this.producto.precioGlobal;
            activo = false;
          } else {
            precio = "-";
            activo = "-";
          }
        }
        let res = {
          nombreMostrar: r.nombre,
          precio: precio,
          asociado: activo,
          id: r.id,
          impuesto: impuesto ? impuesto : r.impuesto,
        };
        return res;
      });
    },
    mostrarIdioma(v) {
      return mostrarIdioma(v);
    },
    cambioPrecio(item) {
      if (this.timeout) this.timeout();
      this.timeout = setTimeout(() => {}, 1000);
    },
    cambiarAsociado(item) {
      console.log(item);
      var f = this.restaurantes.find((rest) => rest.id == item.id);
      let idRest = item.id;
      let catalogoRest = this.catalogosConsultados.find(
        (cC) => cC.rest == idRest
      );
      let productosCatalogoRest = catalogoRest ? catalogoRest.productos : [];
      let productoFoundIndex = productosCatalogoRest.findIndex(
        (pCR) => pCR.id == this.producto.id
      );
      if (this.eleccionLote == "producto") {
        if (productoFoundIndex > -1) {
          console.log(productoFoundIndex);
          catalogoRest.productos[productoFoundIndex].precio = item.precio;
          catalogoRest.productos[productoFoundIndex].impuesto = item.impuesto;
          catalogoRest.productos[productoFoundIndex].activo = item.asociado;
        } else {
          if (!Array.isArray(catalogoRest.productos))
            catalogoRest.productos = [];
          catalogoRest.productos.push({
            precio: item.precio,
            impuesto: item.impuesto,
            activo: item.asociado,
            id: this.producto.id,
          });
        }
      } else {
        //es opción
        console.log(catalogoRest.productos[productoFoundIndex]);
        var opcionesAsoc = Array.isArray(
          catalogoRest.productos[productoFoundIndex].opciones
        )
          ? catalogoRest.productos[productoFoundIndex].opciones
          : [];

        let idBuscar = this.eleccionLote
          ? this.eleccionLote.replace("opcion_", "")
          : null;
        console.log(opcionesAsoc);
        var findAsoc = opcionesAsoc.findIndex((as) => as.id == idBuscar);
        console.log(findAsoc);
        if (findAsoc > -1) {
          console.log("no push");
          catalogoRest.productos[productoFoundIndex].opciones[findAsoc].precio =
            item.precio;
          catalogoRest.productos[productoFoundIndex].opciones[findAsoc].activo =
            item.asociado;
        } else {
          console.log("push");
          if (
            !Array.isArray(catalogoRest.productos[productoFoundIndex].opciones)
          )
            catalogoRest.productos[productoFoundIndex].opciones = [];
          catalogoRest.productos[productoFoundIndex].opciones.push({
            precio: item.precio,
            impuesto: item.impuesto,
            activo: item.asociado,
            id: idBuscar,
          });
        }
        console.log(idBuscar);
        console.log(findAsoc);
      }

      console.log(catalogoRest);
      this.$store
        .dispatch("catalogos/setCatalogoRest", [
          {
            catalogo: this.catalogoViendo,
            rest: idRest,
            productos: catalogoRest.productos,
          },
        ])
        .then((r) => {
          this.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Asociacion guardada",
          });
          this.calcularRestaurantesFiltrados();
        })
        .catch((e) => {
          console.log(e);
          this.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al guardar las asociaciones",
          });
        })
        .finally(() => {
          item.loading = false;
        });

      if (f) {
        var foundCatalogoRest = this.restaurantesFiltrados.find(
          (rCat) => rCat.id == item.id
        );
        var asociaciones = foundCatalogoRest ? foundCatalogoRest.productos : [];
        return;
        if (this.eleccionLote == "producto") {
          if (item.asociado) {
            //comprobamos si ya estaba asociado
            var findAsoc = asociaciones.findIndex(
              (as) => as.id == this.producto.id
            );
            if (findAsoc > -1) {
              //está asociado
              asociaciones[findAsoc].precioRest = item.precio;
              asociaciones[findAsoc].impuesto = item.impuesto;
            } else {
              //asociamos por primera vez
              let opciones = [];
              if (this.producto.opciones) {
                this.producto.opciones.forEach((p_aux) => {
                  p_aux.opciones.forEach((op) => {
                    let aux_op = {
                      id: op.id,
                      precio: op.precio ? op.precio : 0,
                      asociado: true,
                    };
                    opciones.push(aux_op);
                  });
                });
              }
              let aux = {
                id: this.producto.id,
                impuesto: item.impuesto,
                precioRest: this.producto.precioGlobal
                  ? this.producto.precioGlobal
                  : 0,
                opciones: opciones,
              };
              asociaciones.push(aux);
            }
          } else {
            //desasociar
            asociaciones = asociaciones.filter(
              (p) => p.id !== this.producto.id
            );
          }
        } else {
          //es opción
          let idBuscar = this.eleccionLote
            ? this.eleccionLote.replace("opcion_", "")
            : null;
          var findAsoc = asociaciones.findIndex(
            (as) => as.id == this.producto.id
          );
          if (findAsoc > -1) {
            //comprobamos si el producto está aqsociado, debería
            let findOpAsoc = asociaciones[findAsoc].opciones.findIndex(
              (op) => op.id === idBuscar
            );
            if (findOpAsoc > -1) {
              asociaciones[findAsoc].opciones[findOpAsoc].asociado =
                item.asociado;
              asociaciones[findAsoc].opciones[findOpAsoc].precio = parseFloat(
                item.precio
              );
            } else {
              asociaciones[findAsoc].opciones.push({
                asociado: item.asociado,
                precio: item.precio,
                id: idBuscar,
              });
            }
          }
        }
        item.loading = true;
        let _vm = this;
        this.$store
          .dispatch("productos/saveAsociacionPorLote", {
            asociaciones: asociaciones,
            restaurante: item.id,
          })
          .then((r) => {
            _vm.$store.commit("snackbar/setMensajeSuccess", {
              msj: "Asociacion guardada",
            });
          })
          .catch((e) => {
            console.log(e);
            _vm.$store.commit("snackbar/setMensajeDanger", {
              msj: "Error al guardar las asociaciones",
            });
          })
          .finally(() => {
            item.loading = false;
          });
      }
    },
  },
  beforeMount() {
    let found = this.$store.state.productos.productosArray.find(
      (e) => e.id == this.$route.params.idProducto
    );
    if (found) {
      this.producto = found;
    } else {
      let str = "/admin/gest/" + this.negocio.id + "/almacen/productos";
      this.$router.push(str);
    }
  },
  mounted() {
    this.catalogoViendo = "online-domicilio";
  },
};
</script>

<style>
</style>